<!-- <ion-header>
	<app-order-page-toolbar
		(backClick)="backClick()"
		[preorderType]="order?.preorder?.type"
		(close)="backClick()"
		[title]="title"
	></app-order-page-toolbar>
</ion-header> -->

<ion-content>
	<app-order-content></app-order-content>
</ion-content>
